module.exports = __webpack_public_path__ + "static/media/yellow-signs-home.78f336c6.jpg";